import { useUser } from "../context/useUser";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/header";

export default function SignIn() {
  const { user, setUser, signIn } = useUser();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signIn(user.email, user.password);
      navigate("/");
    } catch (error) {
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : "Login failed";
      alert(message);
    }
  };

return (
  <>
    <Header />

    <div className="signin-container">
      <div className="signin-box">
      <div className="signin-content">
        
        <h2 className="signin-title">Kirjautuminen</h2>

        <form onSubmit={handleSubmit} className="default-form">
          <input
            type="email"
            placeholder="Sähköpostiosoite"
            value={user.email}
            onChange={(e) => setUser({ ...user, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Salasana"
            value={user.password}
            onChange={(e) => setUser({ ...user, password: e.target.value })}
            required
          />

          <div className="forgot-link-container">
            <Link to="/forgot-password" className="forgot-link">
              Unohtuiko salasana?
            </Link>
          </div>

          <button type="submit" className="default-button">
            Kirjaudu
          </button>
        </form>
      </div>
      </div>
    </div>
  </>
)}
